export enum Category1Types {
  INGREDIENTS = 'Ingredients',
  PACKAGING_MATERIALS = 'Packaging Materials',
  OTHERS = 'Others',
  FERTILISERS = 'Fertilisers'
}

export enum Category1TypeFields {
  INGREDIENTS = 'ingredients',
  PACKAGING_MATERIALS = 'packagings',
  OTHERS = 'others',
  FERTILISERS = 'fertilizers'
}

export enum Category1TypeSections {
  INGREDIENTS = 'Add Ingredient',
  PACKAGING_MATERIALS = 'Add Packaging Material',
  OTHERS = 'Add Others',
  FERTILISERS = 'Fertilisers'
}